import { render, staticRenderFns } from "./TooltipInformativo.vue?vue&type=template&id=38888d06&scoped=true"
import script from "./TooltipInformativo.vue?vue&type=script&lang=js"
export * from "./TooltipInformativo.vue?vue&type=script&lang=js"
import style0 from "./TooltipInformativo.vue?vue&type=style&index=0&id=38888d06&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38888d06",
  null
  
)

export default component.exports